// DS: MO0.2
import React from 'react';
import c from 'classnames';
import { URLS } from '@wix/da-url';
import TextButton from '../Buttons/TextButton';
import CoreSymbol from '../Indicators/CoreSymbol';
import { IconSize } from '../Icons/IconWrap';
import s from './DisclosureBanner.scss';
const DisclosureBanner = ({ title, message, ctaLabel, ctaBiData, className, variant = 'vetical' })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], s[`variant-${variant}`], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: s['message']
    }, message), ctaLabel && /*#__PURE__*/ React.createElement(TextButton, {
        size: "small",
        variant: "core-orange",
        className: s['cta'],
        href: URLS.CORE_MEMBERSHIP,
        biData: ctaBiData
    }, /*#__PURE__*/ React.createElement(CoreSymbol, {
        className: s['core-star'],
        size: IconSize.MEDIUM
    }), ctaLabel));
};
DisclosureBanner.displayName = 'DisclosureBanner';
export default DisclosureBanner;
